import React from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { Container } from '@material-ui/core';

import { termsHTML } from './terms-20220504';

const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(3),
        // width: '100%',
    },
    container: {
        margin: theme.spacing(3),
        // width: '100%',
    },
}));

const TermsOfUse = () => {
    const classes = useStyles();

    return (
        <Container fixed>
            <Paper elevation={3} className={classes.container}>
                <Container fixed>
                    <div dangerouslySetInnerHTML={{ __html: termsHTML }} />
                </Container>
            </Paper>
        </Container>
    );
};

export default injectIntl(TermsOfUse);
